import { render, staticRenderFns } from "./RadioSelect.vue?vue&type=template&id=20a033a7&scoped=true&"
import script from "./RadioSelect.vue?vue&type=script&lang=js&"
export * from "./RadioSelect.vue?vue&type=script&lang=js&"
import style0 from "./RadioSelect.vue?vue&type=style&index=0&id=20a033a7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a033a7",
  null
  
)

export default component.exports